import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthenticationService } from './authentication.service';

export const roleInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthenticationService);
  // const role = authService.getCurrentUserRole();
  const accountType = authService.getAccountType();
  const mdaId = authService.getCurrentUserMda();

  // if (role === 'ADMIN') {
  if (accountType === 'ADMIN') {
    const modifiedReq = req.clone({
      params: req.params.set('mdaId', mdaId).append('mda_id', mdaId ?? ''),
    });
    return next(modifiedReq);
  }
  return next(req);
};